// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606151303/js/" + chunkId + "." + {"44":"8eae7d3b","225":"f9d0ffca","481":"08154bb1","486":"4d2596d7","770":"a87ba9cd"}[chunkId] + ".0.48089707022921746.chunk.js";
};